import React from "react";

import { applicationListPermissionSet } from "helpers";
import { useApplicationSearchQuery } from "queries";

import { applicationResultItem } from "../resultItems";

import ApplicationIcon from "static/images/application.png";

const applicationSection = () => {
	return {
		name: "applications",
		title: "Application",
		useSearchQuery: useApplicationSearchQuery,
		renderItem: applicationResultItem,
		getIcon: () => <img src={ApplicationIcon} alt="" />,
		getLink: ({ id }) => `/applications/${id}`,
		requiredPermissions: applicationListPermissionSet,
	};
};

export default applicationSection;
